import Footer from '../footer.vue'
import webFooter from '../webFooter.vue'
import IndexLocation from '../indexLocation.vue'
import Repeatlogin from '../repeatlogin.vue'
import {CommonUtil} from '../../common/CommonUtil'
import {store} from '../../store/store.js'
import {StorageUtil} from '../../common/Auth'
import {api,imgPath} from '../../common/config.js';
import {ajaxUtil} from "../../common/AjaxUtil.js";

export default {
  name: 'wrap',
  components: {
    Footer,
    IndexLocation,
    Repeatlogin,
    webFooter
  },
  data() {
    return {
      webType: store.webType,
      opacType: store.opacType,
      isPc: true, /*判断是PC端还是安卓端*/
      activeRouteName: '首页',
      fixed: true,
      user: null,
      showFooter: true,
      latLng: store.localtionArea ? "104.0658,30.65734" : store.localtionArea.latLng,
      hallCode: '',
      currAreaDesc: "",
      currAreaCode: "",
      messageCount: 0,
      unreadCount: 0,
      authorizedLogin: false,//是否是授权登录方式
      readerData: {image: "", idCard: "", phone: ""},
      imgError: store.imgError_headerIco,
      imgPath:imgPath
    }
  },
  computed: {
    count() {
      return this.messageCount + this.unreadCount
    },
    libId() {
      return store.library.libId || '';
    },
    libLevel() {
      return store.library.libLevel || '';
    },
    libraryName() {
      return this.$route.query.hallCode || '';
    },
    menu() {
      let opacMenu = [];
      if(store.opacType == 1){
        if(store.menu.length>8){
            opacMenu[0] = store.menu[0];
            opacMenu[1] = store.menu[5];
            opacMenu[2] = store.menu[1];
            opacMenu[3] = store.menu[2];
            opacMenu[4] = store.menu[3];
            opacMenu[5] = store.menu[4];
            opacMenu[6] = store.menu[6];
            opacMenu[7] = store.menu[7];
        }else{
            opacMenu[0] = store.menu[0];
            opacMenu[1] = store.menu[5];
            opacMenu[2] = store.menu[1];
            opacMenu[3] = store.menu[2];
            opacMenu[4] = store.menu[3];
            opacMenu[5] = store.menu[4];
            opacMenu[6] = store.menu[6];
        }
        return opacMenu
      }else{
        return store.menu
      }
    }
  },
  created() {
    if(store.wrap){
        this.messageCount = store.wrap.messageCount;
        this.unreadCount = store.wrap.unreadCount;
    }
    store.wrap = this;
    if (StorageUtil.getString("authorizedLogin")) {
      this.authorizedLogin = true;
    }
  },
  async beforeMount() {
    let u = CommonUtil.getHashParams();
    let tk = u.access_token;
    if (tk != undefined && tk != null && tk != '') {
      StorageUtil.storeString("authorizedLogin", true);
      this.authorizedLogin = true;
    }
    await this.getUser();
    store.token = !StorageUtil.getString("token") ? '' : StorageUtil.getString("token");
    store.user = !StorageUtil.getObject("user") ? '' : StorageUtil.getObject("user");
    this.isPc = CommonUtil.checkPlatform() == 1 ? false : true
    this.user = store.func.getUserObj();
    //定位设置
    if (StorageUtil.getObject("localtionArea") != null) {
      store.localtionArea = StorageUtil.getObject("localtionArea");
    }
    if (StorageUtil.getObject("choosedCitys") != null) {
      store.choosedCitys = StorageUtil.getObject("choosedCitys");
    }
    if (StorageUtil.getObject("chooseArea") == null) {
      store.chooseArea = StorageUtil.getObject("chooseArea");
      setTimeout(this.initLocationFunc, 2000);
    } else {
      store.chooseArea = StorageUtil.getObject("chooseArea");
      this.currAreaDesc = store.chooseArea.desc;
      this.currAreaCode = store.chooseArea.code;
    }
  },
  watch:{
      'user':{
          handler(){
              if(StorageUtil.getObject("user")){
                  this.readerData = StorageUtil.getObject("user");
              }
          },
          deep:true
      }
  },
  methods: {
    goBack(){
        this.$router.go(-1)
    },
    async getUser() {
      if (store.user) {
        return false
      }else if(this.$route.query.ssoid){
        var data = {ticket: this.$route.query.ssoid,serviceType:"lasa"};
             this.getSsoid(data);
      }else if(this.$route.query.iflyssost){
        var data = {ticket: this.$route.query.iflyssost,serviceType:"jyyun"};
             this.getSsoid(data);
      }
    },
    async getSsoid(data) {
      var url = api.auth.ticket;
      var _this=this;
      await ajaxUtil.ajaxJson(url, data, "POST", (data) => {
        if(data==null){
         return;
        }
        store.user = data.reader;
        _this.user= data.reader;
        store.token = data.token;
        StorageUtil.storeString('token', data.token);
        StorageUtil.storeObject('user',data.reader);
        CommonUtil.setCookie("loginStart", "true", 0.375);//0.375
        CommonUtil.setCookie("noMovingTime", "true", 0.125);//0.125
      }, (error) => {
      }, this)
    },
    tosurface() {
      this.$router.push('/skin/skinlist')
    },
    initLocationFunc() {
      this.currAreaDesc = store.chooseArea.desc;
      this.currAreaCode = store.chooseArea.code;
      this.latLng = store.localtionArea.latLng;
    },
    choose(name) {
        this.activeRouteName = name;
    },
    getAllNum() {
      //未读消息量
      if (!this.user) {
        return false
      }
      var url = api.personalnews.overdue.replace('{idCard}', this.user.idCard);
      ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
        this.messageCount = data.messageCount;
      }, null, this)
      var otherNewsUrl = api.personal.getUnreadcount;
      ajaxUtil.ajaxJson(otherNewsUrl, {readerId: this.user.readerId}, 'POST', (data) => {
        this.unreadCount = data.unreadCount
      }, null, this)
    },
    toPerson() {
      if (this.user != null) {
        this.$router.push({path: '/apply', query: {hallCode: this.libraryName}});
      } else {
        store.index.$refs.login.showLogin();
      }
    },
    selectLocation() {
      this.$refs.location.toggleShow()
    },
  }
}
